import React, { useState, useEffect } from 'react'
import { CContainer, CRow, CForm, CCol } from '@coreui/react'
import ContentHeader from "../ContentHeader/ContentHeader";
import Select from "react-select";
import {
  authenticateProceumToken,
  CurriculumList,
  SubjectList,
  ChapterList,
  ContentData
} from '../../Services/ApiService'
import { toast } from 'react-toastify';
import parse from 'react-html-parser'

const ProceumContent = () => {

  const [proceumtoken, setproceumtoken] = useState(localStorage.getItem("protoken"));

  const [curriculum, setCurriculum] = useState('');
  const [curriculumList, setCurriculumList] = useState([]);

  const [subject, setSubject] = useState('');
  const [subjectList, setsubjectList] = useState([]);

  const [chapter, setChapter] = useState('');
  const [chapterList, setchapterList] = useState([]);
  const [topic, setTopic] = useState('');
  const [topicList, setTopicList] = useState([]);
  const [subTopicList, setSubTopicList] = useState([]);
  const [contentDataList, setContentDataList] = useState('');

  const [subTopic, setSubTopic] = useState('');

  const [typeNameId, setTypeNameId] = useState('');
  const [curriculumNameId, setCurriculumNameId] = useState('');


  useEffect(() => {
    const authenToken = async () => {
      if (proceumtoken === "" || proceumtoken === undefined || proceumtoken === null) {
        let response;
        try {
          response = await authenticateProceumToken();
          console.log(response);
          if (response?.data && response?.data?.token !== "") {
            localStorage.setItem("protoken", response?.data?.token);
            setproceumtoken(response?.data?.token)
            curriculumListFunc(response?.data?.token)
          } else {
            localStorage.setItem("protoken", "");
            setproceumtoken("")
          }
        } catch (e) {
        }
      } else {

      }
    }
    authenToken()
  }, [])
  // console.log(proceumtoken, "proceumtoken");

  const curriculumListFunc = async (token) => {
    let body = {
      "type": "curriculum"
    }
    try {
      const response = await CurriculumList(body, token)
      // console.log(response, "eeeeeeeeeeee")
      if (response.data) {
        let dataOption = response.data.map((x) => ({
          value: x.id,
          label: x.name,
        }))
        setCurriculumList(dataOption)
        setTypeNameId(response.data[0].type_name)
        setCurriculumNameId(response.data[0].id)
      } else {
        toast.error(response.message)
      }
    } catch (e) {
      console.log(e, "Error")
    }
  }

  // console.log(curriculumNameId, "curriculum")

  const subjectListFunc = async () => {
    let body = {
      "type": "subject",
      "curriculum_name": curriculumNameId,
      "type_name": typeNameId,
    }
    try {
      const response = await SubjectList(body);
      // console.log(body)
      if (response.data) {
        let dataOption = response.data.map((x) => ({
          value: x.id,
          label: x.name,
        }))
        setsubjectList(dataOption)
      } else {
        toast.error(response.message);
      }
    } catch (e) {
      console.log(e, "Error")
    }
  }

  const chapterListFunc = async (subject) => {
    let body = {
      "type": "chapter",
      "curriculum_name": curriculumNameId,
      "subject_name": subject.value,
      "type_name": typeNameId,
    }
    try {
      const response = await ChapterList(body)
      if (response.data) {
        let dataOption = response.data.levels.map((x) => ({
          value: x.id,
          label: x.name,
          topics: x?.topics
        }));
        setchapterList(dataOption)
        console.log(dataOption, "dataOptiondataOption")
      } else {
        toast.error(response.message)
      }
    } catch (e) {
      console.log(e, "Error")
    }
  }

  const onchangeChapterData = async (val) => {
    setChapter(val)
    setTopic(null);
    setSubTopic(null);

    if (val?.topics?.length > 0) {

      let dataOption = val?.topics?.map((x) => ({
        value: x.id,
        label: x.name,
        level_name: x?.level_name,
        sub_topics: x?.sub_topics
      }));
      setTopicList(dataOption)
    } else {
      setTopicList([])
    }
  }

  const onchangeTopicData = async (val) => {
    setTopic(val);
    setSubTopic(null);
    setSubTopicList([])
    if (val?.sub_topics?.length > 0) {

      let dataOption = val?.sub_topics?.map((x) => ({
        value: x.id,
        label: x.name,
        level_name: x?.level_name,
      }));


      setSubTopicList(dataOption)
    }
  }

  const contentdataFunc = async (parentName, levelName) => {
    let body = {
      "curriculum_name": curriculumNameId,
      "level_name": levelName,
      "parent_name": parentName,
      "type_name": typeNameId,
    }
    console.log(body, "contentdataFunc");
    try {
      const response = await ContentData(body)
      console.log(response, "responseresponse")
      if (response?.data) {
        viewHTML(response.data)
      } else {
        toast.error(response.message)
      }
    } catch (e) {
      console.log(e, "Error")
    }
  }

  const viewHTML = async (jsonData) => {
    let htmlContent = '';

    // Add Content List
    if (jsonData?.content_list?.length > 0) {
      const contentList = jsonData.content_list.map(content => `
      <li>${content.title} - Reading Time: ${content.reading_time} mins</li>
      `).join('');

      htmlContent += `
    <div class="proc_section">
    <h2>Content List</h2>
    <ul>${contentList}</ul>
    </div>
    `;
    }

    // Add Videos
    if (jsonData?.videos?.length > 0) {
      const videoSection = jsonData.videos.map(video => `
          <div>
              <h3>${video.title}</h3>
              <img src="${video.thumbnail_image}" alt="${video.title}">
          </div>
      `).join('');
      htmlContent += `
      <div class="section">
        <h2 style="display:flex; justify-content:center; margin-top:4%">
          Videos
        </h2>
        ${videoSection}
      </div>`;
    }

    // Add Learning Notes
    if (jsonData.learning_notes) {
      const notesSection = jsonData.learning_notes.map(section => {
        const notesContent = section.notes.map(note => `
            <div class="notes">
                <h3>${note.title || 'Untitled Note'}</h3>
                ${note.notes || '<p>No content available.</p>'}
            </div>
        `).join('');
        return `
            <div class="section"  style="margin-left:10px;">
                <h2 style="font-weight:bold;">${section.head_name || 'Learning Notes Section'}</h2>
                ${notesContent}
            </div>
        `;
      }).join('');
      htmlContent += `<div class="section"><h2 style="display:flex; justify-content:center">Learning Notes</h2>${notesSection}</div>`;
    }

    // Add High Yields
    if (jsonData.highyields) {
      const highYieldsSection = jsonData.highyields.map(section => {
        const notesContent = section.notes.map(note => `
              <div class="notes">
                  <h3>${note.title || 'Untitled Note'}</h3>
                  ${note.notes || '<p>No content available.</p>'}
              </div>
          `).join('');
        return `
              <div class="section">
                  <h2>${section.head_name || 'High Yields Section'}</h2>
                  ${notesContent}
              </div>
          `;
      }).join('');
      htmlContent += `<div class="section"><h2 style="display:flex; justify-content:center; margin-top:-30%">High Yields</h2>${highYieldsSection}</div>`;
    }

    // Add MCQs
    if (jsonData.mcqs) {
      const mcqsSection = jsonData.mcqs.map(mcq => {
        // Generate the options
        const optionsHtml = mcq?.options?.map(option => {
          const isCorrect = mcq.correct_answers.includes(option?.pk_id?.toString());
          const optionClass = isCorrect ? 'correct' : 'incorrect'; // Mark correct options
          return `
          <li class="${optionClass}">
            ${option.text}
          </li>
        `;
        }).join('');

        // Render the MCQ question and options
        return `
        <div class="mcq-question">
          <h3>Question: ${mcq.question}</h3>
          <ul>${optionsHtml}</ul>
          <div class="explanation">
            <h4>Explanation:</h4>
            ${mcq.explanation || '<p>No explanation available.</p>'}
          </div>
        </div>
      `;
      }).join('');

      htmlContent += `<div class="section"><h2 style="display:flex; justify-content:center; margin-top:6%">MCQs</h2>${mcqsSection}</div>`;
    }

    // Render Cases Section
    if (jsonData.cases) {
      const casesSection = jsonData.cases.map(caseItem => {
        return `
              <div class="section">
                  <p><strong>Question:</strong> ${caseItem.question}</p>
                  <p><strong>Explanation:</strong> ${caseItem.explanation}</p>
                  <ul>
                      <li><strong>Option A:</strong> ${caseItem.options[0].text}</li>
                      <li><strong>Option B:</strong> ${caseItem.options[1].text}</li>
                      <li><strong>Option C:</strong> ${caseItem.options[2].text}</li>
                      <li><strong>Option D:</strong> ${caseItem.options[3].text}</li>
                  </ul>
                  <p><strong>Correct Answer:</strong> Option ${caseItem.correct_answers[0]}</p>
              </div>
          `;
      }).join('');
      htmlContent += `<div class="section"><h2 style="display:flex; justify-content:center; margin-top:5%">Cases</h2>${casesSection}</div>`;
    }

    // Add Content Section
    if (jsonData.content) {
      const content = jsonData.content;
      const contentSection = `
        <div class="section">
          <h2>${content.title}</h2>
          <p><strong>Reading Time:</strong> ${content.reading_time}</p>

          <!-- Main Content Section -->
          <h3>Main Content</h3>
          <p>${content.main_content || 'No main content available.'}</p>

          <!-- Learning Objectives Section -->
          <h3>Learning Objectives</h3>
          <p>${content.learning_obj_content || 'No learning objectives available.'}</p>

          <!-- Learning Notes Section -->
          <h3>Learning Notes</h3>
          <p>${content.learning_notes_content || 'No learning notes available.'}</p>

          <!-- External References Section -->
          <h3>External References</h3>
          <div class="external-links">
            <ul>
              ${content.external_ref_content.split('\n').map(ref => {
        if (ref.trim()) {
          const [title, url] = ref.split('\n');
          return `<li><a href="${url}"${title}</a></li>`;
        }
      }).join('')}
            </ul>
          </div>

          <!-- Last Updated Section -->
          <h3>Last Updated:</h3>
          <p>${content.last_updated}</p>
        </div>
      `;
      // Append the generated content to the container
      htmlContent += `<div class="section"><h2 style="display:flex; justify-content:center; margin-top:5%">Content Section</h2>${contentSection}</div>`;
    }

    setContentDataList(htmlContent);

  }

  return (
    <CContainer fluid className="bg-white paddingLeft-0 paddingRight-0">
      <div style={{ height: 'auto', color: 'black', marginBottom: '40px' }}>

        <ContentHeader
          name={"Proceum Content"}
        />
        <CContainer fluid style={{ backgroundColor: "white", padding: "30px 30px" }}>
          <div style={{ backgroundColor: "white" }}>
            <CForm>
              <CRow className={"form-container-row"}>
                <CCol md="12" lg="12" sm="12">

                  <CRow className={"marginTop-15"}>
                    <CCol sm="6" md="4" lg="5" >
                      <h6 className={"Frm_M_Label_qygX2"} >Curriculum <span className="text-danger">*</span></h6>
                      <Select
                        onChange={(e) => {
                          setCurriculum(e);
                          subjectListFunc();
                        }}
                        value={curriculum}
                        options={curriculumList}
                        placeholder={"Select Curriculum"}
                      />
                    </CCol>

                    <CCol sm="6" md="4" lg="5" >
                      <h6 className={"Frm_M_Label_qygX2"} >Subject  <span className="text-danger">*</span></h6>
                      <Select
                        onChange={(e) => {
                          setSubject(e)
                          chapterListFunc(e)
                          setChapter('');
                          setTopic('');
                          setSubTopic('');
                          setSubTopicList([]);
                          setContentDataList('');
                        }}
                        value={subject}
                        options={subjectList}
                        placeholder={"Select Subject List"}
                      />
                    </CCol>

                    {/* <CRow className={"marginTop-15"}> */}
                    <CCol sm="6" md="4" lg="4" className={"marginTop-15 pt-2"}>
                      <h6 className={"Frm_M_Label_qygX2"} >Chapter  <span className="text-danger">*</span></h6>
                      <Select
                        onChange={(e) => {
                          onchangeChapterData(e)
                        }}
                        value={chapter}
                        options={chapterList}
                        placeholder={"Select Chapter List"}
                      />
                    </CCol>


                    {chapter && topicList.length > 0 ? (
                      <>
                        <CCol sm="6" md="4" lg="4" className={"marginTop-15 pt-2"}>
                          <h6 className="Frm_M_Label_qygX2">
                            Topic <span className="text-danger">*</span>
                          </h6>
                          <Select
                            onChange={(e) => {
                              onchangeTopicData(e)
                              if (e?.sub_topics.length === 0) {
                                contentdataFunc(e?.value, e?.level_name)
                              }
                            }}
                            value={topic} // Consider changing this to topic.value if needed
                            options={topicList}
                            placeholder="Select Topic"
                          />
                        </CCol>
                      </>
                    ) : null}


                    {topicList && subTopicList.length > 0 ? (
                      <>
                        <CCol sm="6" md="4" lg="4" className={"marginTop-15 pt-2"}>
                          <h6 className={"Frm_M_Label_qygX2"} >Sub - Topic  <span className="text-danger">*</span></h6>
                          <Select
                            onChange={(e) => {
                              setSubTopic(e)
                              contentdataFunc(e?.value, e?.level_name)
                            }}
                            value={subTopic}
                            options={subTopicList}
                            placeholder={"Select Topic"}
                          />
                        </CCol>
                      </>
                    ) : null
                    }
                  </CRow>
                </CCol>
              </CRow>
            </CForm>

            <br /><br />
            {contentDataList !== "" &&
              <div style={{ fontSize: "20px" }}>{parse(contentDataList)}</div>
            }

          </div>
        </CContainer>
      </div>
    </CContainer>
  )
}

export default ProceumContent
